module.exports = __webpack_public_path__ + "img/nissan02.9fe2d46a.png";